import { useQuery } from '@tanstack/react-query';
import { solicitacaoService } from '../../services/solicitacaoService';

/** Factory de query keys hierárquica — mesmo padrão já usado em Dashboard/OKR. */
export const SI_SOLICITACOES_QUERY_KEYS = {
  all: ['si', 'solicitacoes'] as const,
  filaTrabalho: () => [...SI_SOLICITACOES_QUERY_KEYS.all, 'fila-trabalho'] as const,
  porSolicitante: (solicitanteId: string) =>
    [...SI_SOLICITACOES_QUERY_KEYS.all, 'por-solicitante', solicitanteId] as const,
  porAlocacaoResponsavel: (responsavelId: string) =>
    [...SI_SOLICITACOES_QUERY_KEYS.all, 'por-alocacao-responsavel', responsavelId] as const,
  detalhe: (id: string) => [...SI_SOLICITACOES_QUERY_KEYS.all, 'detalhe', id] as const,
  porTimeRh: (emails: string[]) => [...SI_SOLICITACOES_QUERY_KEYS.all, 'por-time-rh', ...emails] as const,
};

/** Fila de pendências do SI (Discovery §26 — tela padrão do módulo). */
export function useFilaTrabalhoQuery() {
  return useQuery({
    queryKey: SI_SOLICITACOES_QUERY_KEYS.filaTrabalho(),
    queryFn: () => solicitacaoService.getFilaTrabalho(),
  });
}

/** "Solicitações que eu abri" (Discovery §10.2). */
export function useSolicitacoesPorSolicitanteQuery(solicitanteId: string | undefined) {
  return useQuery({
    queryKey: SI_SOLICITACOES_QUERY_KEYS.porSolicitante(solicitanteId ?? ''),
    queryFn: () => solicitacaoService.getBySolicitante(solicitanteId as string),
    enabled: Boolean(solicitanteId),
  });
}

/** "Minha Equipe" — Solicitações onde o usuário logado é o Responsável Raro da alocação
 * específica referenciada (ver solicitacaoService.getByAlocacaoResponsavel). */
export function useSolicitacoesPorAlocacaoResponsavelQuery(responsavelId: string | undefined) {
  return useQuery({
    queryKey: SI_SOLICITACOES_QUERY_KEYS.porAlocacaoResponsavel(responsavelId ?? ''),
    queryFn: () => solicitacaoService.getByAlocacaoResponsavel(responsavelId as string),
    enabled: Boolean(responsavelId),
  });
}

/** "Minhas solicitações" de quem tem si_rh: o que qualquer pessoa do time RH abriu. */
export function useSolicitacoesDoTimeRhQuery(emails: string[] | undefined) {
  const ordenados = [...(emails ?? [])].sort();
  return useQuery({
    queryKey: SI_SOLICITACOES_QUERY_KEYS.porTimeRh(ordenados),
    queryFn: () => solicitacaoService.getBySolicitanteEmails(ordenados),
    enabled: ordenados.length > 0,
  });
}
